export class DateHelper {
  static fullMonthDate(date, withTheYear) {
    var d, day, monthIndex, monthNames, year;
    
    monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    d = new Date(Date.parse(date));
    monthIndex = d.getMonth();
    year = d.getFullYear();
    day = d.getDate();

    if (withTheYear) {
      return monthNames[monthIndex] + ' ' + day + ', ' + year;
    } else {
      return monthNames[monthIndex] + ' ' + day;
    }
  };
}
